;(() => {
  const namespace = (globalThis.StylistLocator = globalThis.StylistLocator || {})
  const utils = namespace.utils || {}
  const escapeHtml = utils.escapeHtml || ((value) => (value == null ? '' : String(value)))


  const MARKER_ICON_CONFIGS = {
    elite: {
      svg: () => '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#C7AE78" stroke="#A08B5A" stroke-width="1.5" stroke-linejoin="round"/><circle cx="10" cy="9.375" r="4.375" fill="white"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
    masters: {
      svg: () => '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#5E5E5E" stroke="#3D3D3D" stroke-width="1.5" stroke-linejoin="round"/><circle cx="10" cy="9.375" r="4.375" fill="white"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
    certified_stylist: {
      svg: () => '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#060606" stroke="white" stroke-width="1.5" stroke-linejoin="round"/><circle cx="10" cy="9.375" r="4.375" fill="white"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
    certified_salon: {
      svg: () => '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20 25" fill="none"><path d="M10 0.5C12.5032 0.499875 14.9057 1.48793 16.6846 3.24902C18.3522 4.90011 19.3452 7.1058 19.4834 9.4375L19.5 9.90527C19.4977 13.1454 17.4113 16.6447 15.1797 19.4346C14.0739 20.817 12.9535 22.0001 12.082 22.8574C11.6466 23.2858 11.2738 23.6317 10.998 23.8799C10.8602 24.0039 10.7475 24.1036 10.6631 24.1758C10.6209 24.2119 10.5859 24.2401 10.5596 24.2617C10.5464 24.2725 10.5355 24.2816 10.5273 24.2881C10.5235 24.2911 10.5209 24.2941 10.5186 24.2959C10.5174 24.2968 10.5163 24.2974 10.5156 24.2979L10.5146 24.2988L10.501 24.3086L10.4873 24.3203C10.3515 24.4364 10.1786 24.5 10 24.5C9.86606 24.5 9.73533 24.4643 9.62109 24.3975L9.5127 24.3203C9.31796 24.1516 7.05625 22.1912 4.84277 19.4336C2.60279 16.6429 0.502292 13.1443 0.5 9.90527C0.52503 7.40237 1.53673 5.01009 3.31543 3.24902C4.9832 1.59793 7.19915 0.626529 9.53223 0.511719L10 0.5Z" fill="white" stroke="#333333" stroke-width="1.5" stroke-linejoin="round"/><circle cx="10" cy="9.375" r="4.375" fill="white" stroke="#060606" stroke-width="1.5"/></svg>',
      width: 20,
      height: 25,
      anchorX: 10,
      anchorY: 24,
    },
    default: {
      svg: () => '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#060606" stroke="white" stroke-width="1.5" stroke-linejoin="round"/><circle cx="10" cy="9.375" r="4.375" fill="white"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
  }

  const CLUSTER_ICON_CONFIGS = {
    elite: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#C7AE78" stroke="#A08B5A" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 5L10 15" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M15 10L5 10" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
    masters: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#5E5E5E" stroke="#3D3D3D" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 5L10 15" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M15 10L5 10" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
    certified_stylist: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#060606" stroke="white" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 5L10 15" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M15 10L5 10" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
    certified_salon: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20 25" fill="none"><path d="M10 0.5C12.5032 0.499875 14.9057 1.48793 16.6846 3.24902C18.3522 4.90011 19.3452 7.1058 19.4834 9.4375L19.5 9.90527C19.4977 13.1454 17.4113 16.6447 15.1797 19.4346C14.0739 20.817 12.9535 22.0001 12.082 22.8574C11.6466 23.2858 11.2738 23.6317 10.998 23.8799C10.8602 24.0039 10.7475 24.1036 10.6631 24.1758C10.6209 24.2119 10.5859 24.2401 10.5596 24.2617C10.5464 24.2725 10.5355 24.2816 10.5273 24.2881C10.5235 24.2911 10.5209 24.2941 10.5186 24.2959C10.5174 24.2968 10.5163 24.2974 10.5156 24.2979L10.5146 24.2988L10.501 24.3086L10.4873 24.3203C10.3515 24.4364 10.1786 24.5 10 24.5C9.86606 24.5 9.73533 24.4643 9.62109 24.3975L9.5127 24.3203C9.31796 24.1516 7.05625 22.1912 4.84277 19.4336C2.60279 16.6429 0.502292 13.1443 0.5 9.90527C0.52503 7.40237 1.53673 5.01009 3.31543 3.24902C4.9832 1.59793 7.19915 0.626529 9.53223 0.511719L10 0.5Z" fill="white" stroke="#333333" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 5L10 15" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/><path d="M15 10L5 10" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/></svg>',
      width: 20,
      height: 25,
      anchorX: 10,
      anchorY: 24,
    },
    default: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="-1 -1 22 27" fill="none"><path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08Z" fill="#060606" stroke="white" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 5L10 15" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M15 10L5 10" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>',
      width: 22,
      height: 27,
      anchorX: 11,
      anchorY: 25,
    },
  }

  function buildSvgIcon({ svg, width, height, anchorX, anchorY }, scale = 1) {
    if (!globalThis.google || !globalThis.google.maps) return null
    const scaledWidth = width * scale
    const scaledHeight = height * scale
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
      scaledSize: new globalThis.google.maps.Size(scaledWidth, scaledHeight),
      anchor: new globalThis.google.maps.Point(anchorX * scale, anchorY * scale),
    }
  }

  function buildMarkerIcon(category = 'default', { active = false } = {}) {
    const scale = active ? 2 : 1.1
    const iconConfig = MARKER_ICON_CONFIGS[category] || MARKER_ICON_CONFIGS.default
    let svg = iconConfig.svg()
    if (active) {
      svg = svg
        .replace(/stroke-width="1.5"/g, 'stroke-width="2"')
        .replace(/viewBox="([^"]*)"/, (_match, vb) => {
          const [x, y, w, h] = vb.split(' ').map(Number)
          return `viewBox="${x - 1} ${y - 1} ${w + 2} ${h + 2}"`
        })
    }
    return buildSvgIcon({ ...iconConfig, svg }, scale)
  }

  function buildUserMarkerIcon() {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#c6ac78" stroke-width="2" fill="#fff"/><circle cx="12" cy="12" r="4" fill="#c6ac78"/></svg>`
    return buildSvgIcon(
      {
        svg,
        width: 24,
        height: 24,
        anchorX: 12,
        anchorY: 12,
      },
      1
    )
  }

  function buildClusterIcon(_count, category = 'default') {
    const iconConfig = CLUSTER_ICON_CONFIGS[category] || CLUSTER_ICON_CONFIGS.default
    const baseScale = 1.1
    return buildSvgIcon(iconConfig, baseScale)
  }

  const ROLE_BADGE_TEMPLATES = {
    elite: () => `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 20 25" fill="none">
        <path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08ZM10 13.75C9.13471 13.75 8.28885 13.4934 7.56938 13.0126C6.84991 12.5319 6.28916 11.8486 5.95803 11.0492C5.62689 10.2498 5.54025 9.37012 5.70906 8.52145C5.87787 7.67279 6.29455 6.89324 6.90641 6.28139C7.51826 5.66954 8.29781 5.25286 9.14648 5.08405C9.99515 4.91524 10.8748 5.00188 11.6742 5.33301C12.4737 5.66414 13.1569 6.2249 13.6377 6.94436C14.1184 7.66382 14.375 8.50968 14.375 9.37497C14.375 10.5353 13.9141 11.6481 13.0936 12.4686C12.2731 13.289 11.1603 13.75 10 13.75Z" fill="#C7AE78"/>
      </svg>
    `,
    masters: () => `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 20 25" fill="none">
        <path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08ZM10 13.75C9.13471 13.75 8.28885 13.4934 7.56938 13.0126C6.84991 12.5319 6.28916 11.8486 5.95803 11.0492C5.62689 10.2498 5.54025 9.37012 5.70906 8.52145C5.87787 7.67279 6.29455 6.89324 6.90641 6.28139C7.51826 5.66954 8.29781 5.25286 9.14648 5.08405C9.99515 4.91524 10.8748 5.00188 11.6742 5.33301C12.4737 5.66414 13.1569 6.2249 13.6377 6.94436C14.1184 7.66382 14.375 8.50968 14.375 9.37497C14.375 10.5353 13.9141 11.6481 13.0936 12.4686C12.2731 13.289 11.1603 13.75 10 13.75Z" fill="#5E5E5E"/>
      </svg>
    `,
    certified_stylist: () => `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 20 25" fill="none">
        <path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08ZM10 13.75C9.13471 13.75 8.28885 13.4934 7.56938 13.0126C6.84991 12.5319 6.28916 11.8486 5.95803 11.0492C5.62689 10.2498 5.54025 9.37012 5.70906 8.52145C5.87787 7.67279 6.29455 6.89324 6.90641 6.28139C7.51826 5.66954 8.29781 5.25286 9.14648 5.08405C9.99515 4.91524 10.8748 5.00188 11.6742 5.33301C12.4737 5.66414 13.1569 6.2249 13.6377 6.94436C14.1184 7.66382 14.375 8.50968 14.375 9.37497C14.375 10.5353 13.9141 11.6481 13.0936 12.4686C12.2731 13.289 11.1603 13.75 10 13.75Z" fill="#060606"/>
      </svg>
    `,
    certified_salon: () => `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 20 25" fill="none">
        <path d="M10 0.5C12.5032 0.499875 14.9057 1.48793 16.6846 3.24902C18.3522 4.90011 19.3452 7.1058 19.4834 9.4375L19.5 9.90527C19.4977 13.1454 17.4113 16.6447 15.1797 19.4346C14.0739 20.817 12.9535 22.0001 12.082 22.8574C11.6466 23.2858 11.2738 23.6317 10.998 23.8799C10.8602 24.0039 10.7475 24.1036 10.6631 24.1758C10.6209 24.2119 10.5859 24.2401 10.5596 24.2617C10.5464 24.2725 10.5355 24.2816 10.5273 24.2881C10.5235 24.2911 10.5209 24.2941 10.5186 24.2959C10.5174 24.2968 10.5163 24.2974 10.5156 24.2979L10.5146 24.2988L10.501 24.3086L10.4873 24.3203C10.3515 24.4364 10.1786 24.5 10 24.5C9.86606 24.5 9.73533 24.4643 9.62109 24.3975L9.5127 24.3203C9.31796 24.1516 7.05625 22.1912 4.84277 19.4336C2.60279 16.6429 0.502292 13.1443 0.5 9.90527C0.52503 7.40237 1.53673 5.01009 3.31543 3.24902C4.9832 1.59793 7.19915 0.626529 9.53223 0.511719L10 0.5Z" fill="white" stroke="#333333" stroke-width="1.5" stroke-linejoin="round"/>
        <circle cx="10" cy="9.375" r="4.875" fill="white"/>
      </svg>
    `,
    default: () => `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 20 25" fill="none">
        <path d="M10 1.25183e-08C7.36507 -0.000131737 4.83657 1.0397 2.96405 2.89348C1.09154 4.74726 0.0263493 7.26518 0 9.89997C0 16.7499 8.8125 24.3749 9.1875 24.6999C9.41392 24.8936 9.70206 25 10 25C10.2979 25 10.5861 24.8936 10.8125 24.6999C11.25 24.3749 20 16.7499 20 9.89997C19.9736 7.26518 18.9085 4.74726 17.0359 2.89348C15.1634 1.0397 12.6349 -0.000131737 10 1.25183e-08ZM10 13.75C9.13471 13.75 8.28885 13.4934 7.56938 13.0126C6.84991 12.5319 6.28916 11.8486 5.95803 11.0492C5.62689 10.2498 5.54025 9.37012 5.70906 8.52145C5.87787 7.67279 6.29455 6.89324 6.90641 6.28139C7.51826 5.66954 8.29781 5.25286 9.14648 5.08405C9.99515 4.91524 10.8748 5.00188 11.6742 5.33301C12.4737 5.66414 13.1569 6.2249 13.6377 6.94436C14.1184 7.66382 14.375 8.50968 14.375 9.37497C14.375 10.5353 13.9141 11.6481 13.0936 12.4686C12.2731 13.289 11.1603 13.75 10 13.75Z" fill="#060606"/>
      </svg>
    `,
  }

  function buildListBadge(stylist, category = 'default', isActive = false) {
    if (!stylist) return ''
    const renderer = ROLE_BADGE_TEMPLATES[category] || ROLE_BADGE_TEMPLATES.default
    return `
      <span class="stylist-locator__card-icon" aria-hidden="true">
        ${renderer(isActive)}
      </span>
    `
  }

  function deriveThumbUrl(fullUrl) {
    if (!fullUrl) return null
    if (fullUrl.includes('placehold.co')) return null
    if (fullUrl.includes('cdn.shopify.com')) return null
    return fullUrl.replace(/\.[a-z0-9]+$/i, '-thumb.jpg')
  }

  function buildGalleryMarkup(stylist) {
    const PLACEHOLDER_IMAGE = 'https://cdn.shopify.com/s/files/1/0298/1186/7708/files/sl-placeholder.png'

    const images = [
      stylist.image_1,
      stylist.image_2,
      stylist.image_3,
      stylist.image_4,
      stylist.image_5,
    ]
      .filter(Boolean)
      .map((src) => {
        // Replace placehold.co placeholder images with Shopify placeholder
        if (src && src.includes('placehold.co/169x169')) {
          return PLACEHOLDER_IMAGE
        }
        return src
      })

    if (images.length === 0) {
      return ''
    }

    const VISIBLE_SLIDE_TARGET = 3
    const visibleCount = Math.min(VISIBLE_SLIDE_TARGET, images.length)
    const galleryLabel = escapeHtml(`${stylist.name || 'Stylist'} portfolio images`)
    const shouldShowControls = images.length > visibleCount

    const slides = images
      .map((src, index) => {
        const safeFull = escapeHtml(src)
        const thumb = deriveThumbUrl(src)
        const safeThumb = thumb ? escapeHtml(thumb) : safeFull
        const altText = escapeHtml(`${stylist.name || 'Stylist'} portfolio image ${index + 1}`)
        const fallbackAttrs = thumb
          ? ` data-full-src="${safeFull}" onerror="this.onerror=null;this.src=this.dataset.fullSrc;"`
          : ''
        return `
          <div class="stylist-locator__gallery-slide" data-gallery-slide data-image-index="${index}" data-image-src="${safeFull}">
            <img src="${safeThumb}" alt="${altText}" loading="lazy"${fallbackAttrs}>
          </div>
        `
      })
      .join('')

    const controls = shouldShowControls
      ? `
          <button class="stylist-locator__gallery-nav stylist-locator__gallery-nav--prev" type="button" data-gallery-prev aria-label="Previous image">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          <button class="stylist-locator__gallery-nav stylist-locator__gallery-nav--next" type="button" data-gallery-next aria-label="Next image">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        `
      : ''

    return `
      <div
        class="stylist-locator__gallery${shouldShowControls ? ' stylist-locator__gallery--has-controls' : ''}"
        data-gallery-root
        data-gallery-visible-count="${visibleCount}"
        data-gallery-total="${images.length}"
        aria-label="${galleryLabel}"
        role="group"
      >
        <div class="stylist-locator__gallery-viewport" data-gallery-viewport>
          <div class="stylist-locator__gallery-track" data-gallery-track>
            ${slides}
          </div>
        </div>
        ${controls}
      </div>
    `
  }

  namespace.templates = Object.assign({}, namespace.templates, {
    buildMarkerIcon,
    buildUserMarkerIcon,
    buildClusterIcon,
    buildListBadge,
    buildGalleryMarkup,
  })
})()
